<div id="tab-settings" class="d-flex flex-column align-items-start gap-2 w-100">
    <h3 class="mb-3">Rankings</h3>
    <p>
        A ranking contains multiple score tables for your games. Manage your rankings here. The active ranking
        determines which tables are shown in the <i>Score Tables</i>-tab.
    </p>
    <div class="spinner-border d-none" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
    <div id="div-rankings" class="d-flex flex-column gap-2 w-100">
    </div>
    <button id="btn-add-ranking" class="btn btn-primary">Add ranking</button>
    <hr>
    <h3 class="mb-3">User account</h3>
    <p>
        Manage your user account here.
    </p>
    <div class="border p-2 gap-4 d-flex flex-column align-items-start">
        <span>You are logged in as <strong class="username">user</strong>.</span>
        <button id="btn-delete-user" class="btn btn-danger">Delete account</button>
    </div>
</div>